<template>
<h1><font-awesome-icon icon="smog" /></h1>
<u>Feinstaub</u>
<br>
<div v-for="b in bars" :key="b.name" class="bar">
  <div class="head">{{ b.name }}: <b>{{ b.valid ? b.value : '--' }}</b> &micro;g/m&sup3;</div>
  <svg viewBox="0 0 200 26" width="200" height="26" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="6" width="200" height="10" rx="5" fill="#fbf3dc" />
    <clipPath :id="`dust-clip-${b.name}`"><rect x="0" y="6" width="200" height="10" rx="5" /></clipPath>
    <g :clip-path="`url(#dust-clip-${b.name})`">
      <rect v-for="z in b.zones" :key="z.x" :x="z.x" y="6" :width="z.w" height="10"
            :fill="z.color" fill-opacity="0.85" />
    </g>
    <rect x="0.5" y="6.5" width="199" height="9" rx="4.5" fill="none" stroke="#5b4510" stroke-width="1" />
    <polygon v-if="b.valid" :points="`${b.x - 5},0 ${b.x + 5},0 ${b.x},9`" fill="#fff" stroke="#3b2e10" stroke-width="1" />
  </svg>
  <div class="level"><span class="dot" :style="{ background: b.color }"></span>{{ b.valid ? b.level : '' }}</div>
</div>
<div class="age">vor <b>{{ age }} s</b></div>
</template>

<script>
const GREEN = '#22a447'
const YELLOW = '#f2d400'
const RED = '#d82a1f'

// limits: [good below, moderate below]; max = scale end (µg/m³)
const SENSORS = [
  { name: 'PM2.5', prop: 'pm25', limits: [15, 25], max: 50 },
  { name: 'PM10', prop: 'pm10', limits: [45, 50], max: 100 }
]

export default {
  name: 'AirDust',
  props: {
    pm25: Number,
    pm10: Number,
    age: Number
  },
  computed: {
    bars() {
      return SENSORS.map(({ name, prop, limits: [good, moderate], max }) => {
        const value = this[prop]
        const valid = Number.isFinite(value)
        const px = v => Math.min(1, Math.max(0, v / max)) * 200
        const level = value < good ? 'gut' : value < moderate ? 'mäßig' : 'schlecht'
        return {
          name,
          value,
          valid,
          level,
          color: value < good ? GREEN : value < moderate ? YELLOW : RED,
          x: valid ? px(value) : 0,
          zones: [
            { x: 0, w: px(good), color: GREEN },
            { x: px(good), w: px(moderate) - px(good), color: YELLOW },
            { x: px(moderate), w: 200 - px(moderate), color: RED }
          ]
        }
      })
    }
  }
}
</script>

<style scoped>
.bar {
  margin-top: 16px;
}

svg {
  display: block;
  margin: 2px auto 0;
}

.level {
  min-height: 1.2em;
}

.dot {
  display: inline-block;
  width: 0.7em;
  height: 0.7em;
  margin-right: 0.4em;
  border-radius: 50%;
  border: 1px solid #fff;
}

.age {
  margin-top: 16px;
}
</style>
